import { render, staticRenderFns } from "./ParcelsMap.vue?vue&type=template&id=88931682"
import script from "./ParcelsMap.vue?vue&type=script&lang=js"
export * from "./ParcelsMap.vue?vue&type=script&lang=js"
import style0 from "./ParcelsMap.vue?vue&type=style&index=0&id=88931682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports